import React from "react";

const StatsBanner = () => {
  const items = [
    "ISO Certified",
    "2500+ Retailers",
    "Farmer-First Focus",
    "15 Branches",
    "Quality Crops",
  ];

  return (
    <section className="w-full overflow-hidden">
      <div
        className="py-[20px] px-4"
        style={{
          background:
            "linear-gradient(270deg, #FFB603 0%, #DB4B12 44.82%, #593747 109.16%)",
        }}
      >
        <div className="flex gap-8 md:gap-[58px] h-[45px] animate-scroll whitespace-nowrap">
          {[...items, ...items].map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-2 md:gap-[27px] text-white font-[LTWave] font-bold text-base md:text-[24px] leading-[100%] shrink-0"
            >
              {/* Star Icon */}
              <svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5168 2.58594C14.4833 -0.0259128 18.1775 -0.0259166 19.1439 2.58594L21.6632 9.39409C21.967 10.2152 22.6145 10.8627 23.4356 11.1665L30.2438 13.6858C32.8556 14.6522 32.8556 18.3464 30.2438 19.3129L23.4356 21.8321C22.6145 22.136 21.967 22.7834 21.6632 23.6046L19.1439 30.4127C18.1775 33.0246 14.4833 33.0246 13.5168 30.4127L10.9976 23.6046C10.6937 22.7834 10.0463 22.136 9.22514 21.8321L2.417 19.3129C-0.194858 18.3464 -0.194862 14.6522 2.41699 13.6858L9.22514 11.1665C10.0463 10.8627 10.6937 10.2152 10.9976 9.39409L13.5168 2.58594Z"
                  fill="white"
                />
              </svg>
              {item}
            </div>
          ))}
        </div>
      </div>

      {/* Tailwind Custom Animation */}
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 15s linear infinite;
        }
      `}</style>
    </section>
  );
};

export default StatsBanner;
